// extracted by mini-css-extract-plugin
module.exports = {"header":"ChoosePhotoModal_header__p6GBz","gallery":"ChoosePhotoModal_gallery__3jT6H","photoItem":"ChoosePhotoModal_photoItem__2Hvuk"};